import { render, staticRenderFns } from "./ThreatsPanel.vue?vue&type=template&id=2f0781bc&"
import script from "./ThreatsPanel.vue?vue&type=script&lang=js&"
export * from "./ThreatsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports